// 搜索事件
const SearchSubmit = _this => {
  let that = _this;
  that.searchFrom.pageSize = 15;
  that.searchFrom.page = that.pageCurrent = 1;
  that.$emit("pageClick", that.searchFrom);
  // toTop();
};
// 展示页码条数
const changeSize = (size, _this, num) => {
  let that = _this;
  console.log(1);
  console.log(_this);
  that.searchFrom.page = that.pageCurrent = 1;
  that.searchFrom.pageSize = size;
  if (num) {
    that.submitSearch(that.searchFrom);
    return;
  }
  that.$emit("pageClick", that.searchFrom);
  // toTop();
};
// 页码点击切换
const changePage = (page, _this, num) => {
  let that = _this;
  that.searchFrom.page = that.pageCurrent = page;
  if (num) {
    that.submitSearch(that.searchFrom);
    return;
  }
  that.$emit("pageClick", that.searchFrom);
  // toTop();
};
const toTop = () => {
  var tBody = document.querySelector(".ivu-table-body");
  tBody.scrollTop = 0;
};
export default {
  SearchSubmit,
  changePage,
  changeSize
};
